import { Component, OnInit, AfterViewInit } from '@angular/core';
import { MenuService } from '../../services/menu.service';
import { FooterData } from '../../models/footerData.interface'
declare let transcend;

@Component({
  selector: 'app-footer-rebranded',
  templateUrl: './footer-rebranded.component.html',
  standalone: false,
})

export class FooterRebrandedComponent implements OnInit, AfterViewInit {
  footerData!: FooterData;
  private menuId = 'footer-rebranded';

  constructor(private menuService: MenuService) {}

  ngOnInit(): void {
    const currentYear = new Date().getFullYear();

    this.menuService.getMenu(this.menuId).subscribe((menu) => {
      if (menu.Items && menu.Items.length > 0) {
        this.footerData = menu.Items[0];
        this.footerData.copyright = this.footerData.copyright.replace('{year}', currentYear.toString());
      }
    });
  }

  ngAfterViewInit(): void {
    if (window['airgap']) {
      const cpraButton = document.getElementById('cpra_button');
      cpraButton.onclick = function () {
        transcend.showConsentManager({ viewState: 'CompleteOptionsToggles' });
      };

      cpraButton.style.display = 'inline-flex';
    }
  }
}
